import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  InfluencersState,
  InfluencerType,
} from "lib/features/influencer/types";

const initialState: InfluencersState = {
  isLoading: false,
  connectedInfluencers: [],
  influencerTypes: [],
};

// Slice
export const influencersSlice = createSlice({
  name: "influencers",
  initialState,
  reducers: {
    setInfluencerTypes(
      state: InfluencersState,
      action: PayloadAction<InfluencerType[]>
    ) {
      state.influencerTypes = action.payload;
    },
  },
});

// Export the reducer
export default influencersSlice.reducer;
